import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import CloseSvg from "../../assets/images/icons8-close.svg";
import Facebook from "../../assets/images/icons8-facebook.svg";
import Instagram from "../../assets/images/icons8-instagram.svg";
import LinkedIn from "../../assets/images/icons8-linkedin.svg";
import Twitter from "../../assets/images/icons8-twitter.svg";
import Whatsapp from "../../assets/images/icons8-whatsapp.svg";

const SectionTwo = ({ post }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewButtonClick = () => setIsModalOpen((v) => !v);
  const handleCloseButtonClick = () => setIsModalOpen(false);

  useEffect(() => {
    AOS.init({ duration: 2000 });
  }, []);

  const formattedDate = post?.created_at
    ? new Date(post.created_at).toLocaleDateString()
    : "";

  // ✅ Fixed blog URL (use /blogs instead of /blog)
  const blogUrl = `https://marichitechai.com/blog/${post?.slug || ""}`;

  const socialLinks = [
    {
      icon: Facebook,
      alt: "facebook",
      url: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        blogUrl
      )}`,
    },
    {
      icon: Twitter,
      alt: "twitter",
      url: `https://twitter.com/intent/tweet?url=${encodeURIComponent(
        blogUrl
      )}&text=${encodeURIComponent(post?.title || "")}`,
    },
    {
      icon: Whatsapp,
      alt: "whatsapp",
      url: `https://wa.me/?text=${encodeURIComponent(
        (post?.title || "") + " " + blogUrl
      )}`,
    },
    {
      icon: LinkedIn,
      alt: "linkedin",
      url: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
        blogUrl
      )}&title=${encodeURIComponent(post?.title || "")}`,
    },
    {
      icon: Instagram,
      alt: "instagram",
      url: "https://www.instagram.com/marichitechai/", // IG doesn’t support direct share
    },
  ];

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "32px",
        padding: "0 16px",
        maxWidth: "1200px",
        margin: "0 auto",
      }}
    >
      {/* Main Content */}
      <div
        style={{
          flex: "1 1 600px",
          maxWidth: "800px",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Metadata */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "16px",
            flexWrap: "wrap",
            gap: "8px",
          }}
          data-aos="fade-up"
        >
          <p
            style={{
              fontSize: "16px",
              color: "white",
              textTransform: "uppercase",
              lineHeight: "1.7",
            }}
          >
            {post?.category || "Blog"}
            {post?.author ? ` • by ${post.author}` : ""}
            {formattedDate ? ` • ${formattedDate}` : ""}
          </p>

          {/* Share Button */}
          <button
            style={{
              padding: "8px 16px",
              backgroundColor: "#ff7d61",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "14px",
              fontWeight: "500",
              transition: "all 0.2s ease",
            }}
            onClick={handleViewButtonClick}
            onMouseOver={(e) => (e.currentTarget.style.opacity = "0.9")}
            onMouseOut={(e) => (e.currentTarget.style.opacity = "1")}
          >
            Share
          </button>
        </div>

        {/* Blog Description */}
        <div
          style={{
            fontSize: "18px",
            color: "white",
            lineHeight: "1.7",
            marginBottom: "32px",
          }}
          data-aos="fade-up"
          dangerouslySetInnerHTML={{ __html: post?.description || "" }}
        />
      </div>

      {/* Backdrop */}
      {isModalOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 999,
          }}
          onClick={handleCloseButtonClick}
        />
      )}

      {/* Share Modal */}
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "#fff",
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 8px 24px rgba(0, 0, 0, 0.2)",
          zIndex: 1000,
          display: isModalOpen ? "block" : "none",
          maxWidth: "450px",
          width: "90%",
        }}
        role="dialog"
        aria-modal="true"
      >
        <header
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
            borderBottom: "1px solid #e5e7eb",
            paddingBottom: "12px",
          }}
        >
          <span
            style={{
              fontSize: "20px",
              fontWeight: "600",
              color: "#1f2937",
            }}
          >
            Share This Post
          </span>
          <img
            src={CloseSvg}
            alt="close"
            style={{
              cursor: "pointer",
              width: "28px",
              height: "28px",
              transition: "transform 0.2s",
            }}
            onClick={handleCloseButtonClick}
            onMouseOver={(e) =>
              (e.currentTarget.style.transform = "rotate(90deg)")}
            onMouseOut={(e) =>
              (e.currentTarget.style.transform = "rotate(0deg)")}
          />
        </header>

        <div>
          <p
            style={{
              fontSize: "15px",
              color: "#4b5563",
              marginBottom: "20px",
              fontWeight: "400",
            }}
          >
            Spread the word via your favorite platform
          </p>

          <ul
            style={{
              display: "flex",
              gap: "20px",
              listStyle: "none",
              padding: 0,
              justifyContent: "center",
            }}
          >
            {socialLinks.map((social, index) => (
              <li key={index}>
                <a
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <img
                    src={social.icon}
                    alt={`icons8-${social.alt}`}
                    style={{
                      width: "40px",
                      height: "40px",
                      transition: "transform 0.3s",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.2)")}
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")}
                  />
                </a>
              </li>
            ))}
          </ul>

          {/* Copy Link Option */}
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <button
              onClick={() => {
                navigator.clipboard.writeText(blogUrl);
                alert("Blog link copied to clipboard!");
              }}
              style={{
                padding: "8px 16px",
                backgroundColor: "#2563eb",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              Copy Link
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
